import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'

import { withStyles } from '@material-ui/core/styles'
import { AppBar, Avatar, Button, Grid, FormControl, Input, InputLabel, Typography, Toolbar, Hidden, Dialog, DialogContent, InputAdornment, IconButton, Snackbar } from '@material-ui/core'
import '../../styles/user-nav.css'
import padlock from '../../images/Icons/padlock.png'
import logout from '../../images/Icons/logout.png'
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

import { getUserAction, changePasswordAction } from '../../actions/user'

const styles = theme => ({
    icon: {
        ':focus .input-box': {
            'color': '#1a3e6e'
        }
    }
});

class UserNav extends Component {
    constructor(props) {
        super(props);

        this.state = {
            userInfo: {},
            isPanelOn: false,
            isChangingPassword: false,
            showPassword: false,
            showConfirmation: false,
            newPassword: '',
            newPasswordConfirm: ''
        };
    }

    componentDidMount() {
        this.props.getUserAction();
    }

    onPanelOpen = () => {
        this.setState(state => ({ isPanelOn: !state.isPanelOn}))
    }

    handlePasswordChangeDialog = () => {
        this.setState(state => ({ isChangingPassword: !state.isChangingPassword}))
    }

    handleChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        });
    };

    handleClickShowPassword = () => {
        this.setState(state => ({ showPassword: !state.showPassword }))
    }

    handleClickShowConfirmation = () => {
        this.setState(state => ({ showConfirmation: !state.showConfirmation }))
    }

    onPasswordChange = (event) => {
        event.preventDefault();

        const auth = {
            password: this.state.newPassword,
            confirmation: this.state.newPasswordConfirm
        }

        this.props.changePasswordAction(auth);
    }

    onLogoff = (event) => {
        event.preventDefault();

        localStorage.clear();
        window.location.reload()
    }

    render(){
        const name = this.props.userInfo.name ? this.props.userInfo.name.match(/(\w+\s*\w*)\s*/).slice(0,1).toString() : undefined;
        return(
            <Fragment>
                <Dialog
                    fullWidth
                    maxWidth={'xs'}
                    open={this.state.isPanelOn}
                    onClose={this.onPanelOpen}
                >
                    <DialogContent
                        className="panel"
                        >
                        <Avatar
                        className="avatar"
                        src={this.props.userInfo.avatar}
                        />
                        <Typography
                            align='center'
                            className='name'>
                            {this.props.userInfo.name}
                        </Typography>
                        <Typography
                            className='info'>
                            {this.props.userInfo.email}
                            <br/>
                            TEL:{this.props.userInfo.phone}
                            <br/>
                            CPF: {this.props.userInfo.document}
                        </Typography>
                        <hr className='horizontal-line'/>
                        <Button
                            className='button'
                            onClick={this.handlePasswordChangeDialog}>
                                <img src={padlock} alt='Trocar senha' className='icon'/>
                                TROCAR SENHA
                        </Button>                            
                        <br/>
                        <Button
                            className='button'
                            onClick={this.onLogoff}>
                                <img src={logout} alt='Sair da conta' className='icon' style={{marginRight: '10px', left: '-60px'}}/>
                                SAIR DA CONTA
                        </Button>

                        <Dialog
                            className='password-change'
                            fullWidth
                            maxWidth={'xs'}
                            open={this.state.isChangingPassword}
                            onClose={this.handlePasswordChangeDialog}>
                            <DialogContent>
                                <FormControl
                                    className='input-box' 
                                    fullWidth>
                                    <InputLabel htmlFor="password-input"
                                        className='input-label'
                                    >
                                        Insira a nova senha
                                    </InputLabel>
                                    <Input
                                        id="password-change"
                                        type={this.state.showPassword ? "text" : "password"} required
                                        name='newPassword'
                                        onChange={this.handleChange}
                                        endAdornment={
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="Muda a visibilidade da senha"
                                                    onClick={this.handleClickShowPassword}
                                                >
                                                {this.state.showPassword ? <Visibility className='icon'/> : <VisibilityOff className='icon'/>}
                                                </IconButton>
                                            </InputAdornment>
                                    }/>
                                </FormControl>
                                <br/>
                                <FormControl
                                    className='input-box' 
                                    fullWidth>
                                    <InputLabel htmlFor="password-input"
                                        className='input-label'
                                    >
                                        Confirme a nova senha
                                    </InputLabel>
                                    <Input
                                        id="password-confirmation"
                                        type={this.state.showConfirmation ? "text" : "password"} required
                                        name='newPasswordConfirm'
                                        onChange={this.handleChange}
                                        endAdornment={
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="Muda a visibilidade da senha"
                                                    onClick={this.handleClickShowConfirmation}
                                                >
                                                {this.state.showPassword ? <Visibility className='icon'/> : <VisibilityOff className='icon'/>}
                                                </IconButton>
                                            </InputAdornment>
                                    }/>
                                </FormControl>
                            <Button
                                className='button'
                                onClick={this.onPasswordChange}>
                                Trocar
                            </Button>
                            </DialogContent>
                        </Dialog>                  
                    </DialogContent>
                </Dialog>
                <AppBar
                className='appbar'
                position='static'>
                    <Toolbar>
                        <Grid
                            container
                            alignItems='center'
                            justify='flex-start'
                            >
                            <Grid item xs={10} md={9}>
                                <Typography
                                    className='title'
                                    type='title'>
                                    CedimTech
                                </Typography>
                            </Grid>
                            <Grid item xs={2} md={3}>
                                <Button
                                    className='user-button'
                                    onClick={this.onPanelOpen}>
                                    <Avatar
                                        className="avatar"
                                        src={this.props.userInfo.avatar}
                                    />
                                    <Hidden smDown>
                                        <Typography
                                            className='username'>
                                            {name}
                                        </Typography>
                                    </Hidden>
                                </Button>
                            </Grid>
                        </Grid>
                    </Toolbar>
                </AppBar>
                <Snackbar 
                    open={this.props.errors.changePassword ? true : false}
                    message={this.props.errors.changePassword}
                    onClose={this.handleSnackbarClose}/>
                <Snackbar 
                    open={this.props.message.changePassword ? true : false}
                    message={this.props.message.changePassword}
                    onClose={this.handleSnackbarClose}/>
            </Fragment>
        )
    }
}

function mapStateToProps(state) {
    return {
        userInfo: state.user.userInfo,
        errors: state.user.errors,
        message: state.user.message
    }   
}

function mapDispatchToProps(dispatch) {
    return {
        getUserAction: () => {
            dispatch(getUserAction())
        },
        changePasswordAction: (auth) => {
            dispatch(changePasswordAction(auth))
        }
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(UserNav)));